import { indexDTFBrandAtom } from '@/state/dtf/atoms'
import { zodResolver } from '@hookform/resolvers/zod'
import { useAtomValue } from 'jotai'
import { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import CoverImages from './components/cover-images'
import ManageForm from './components/manage-form'
import { ManageFormValues, useManageFormSchema } from './components/schema'
import SubmitButton from './components/submit-button'

const defaultValues: ManageFormValues = {
  dtf: {
    icon: '',
    cover: '',
    video: '',
    description: '',
    notesFromCreator: '',
    files: [],
    tags: [],
    basketType: 'percentage-based',
  },
  creator: {
    name: '',
    icon: '',
    link: '',
  },
  curator: {
    name: '',
    icon: '',
    link: '',
  },
  socials: {
    twitter: '',
    telegram: '',
    discord: '',
    website: '',
  },
  files: {
    logo: undefined,
    creatorLogo: undefined,
    curatorLogo: undefined,
    desktopCover: undefined,
  },
}

const IndexDTFManage = () => {
  const manageFormSchema = useManageFormSchema()
  const form = useForm({
    resolver: zodResolver(manageFormSchema),
    defaultValues,
    mode: 'onChange',
  })
  const data = useAtomValue(indexDTFBrandAtom)
  const { reset } = form

  useEffect(() => {
    if (data) {
      const formData = {
        ...defaultValues,
        ...data,
      } as unknown as ManageFormValues

      if (data?.dtf?.tags) {
        formData.dtf = {
          ...formData.dtf,
          tags: data.dtf.tags.map((tag: string) => ({
            value: tag,
            label: tag,
          })),
        }
      }

      reset(formData, { keepDirtyValues: true })
    }
  }, [data, reset])

  return (
    <FormProvider {...form}>
      <div data-testid="dtf-manage" className="grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-2 pr-2 pb-4">
        <ManageForm />
        <div className="flex flex-col gap-2">
          <SubmitButton />
          <CoverImages />
        </div>
      </div>
    </FormProvider>
  )
}

export default IndexDTFManage
